<template>
<div class="cmui-list overflow-h" :style="{boxShadow}">
	<div :class="`clearfix cmui-list-col${realCol}`" :style="containerStyle">
		<slot></slot>
	</div>
</div>
</template>
<script>
export default{
	name:'cmui-list',
	props:{
		col:{type:[Number,Array],default:1},
		space:{type:Number,default:0},
		border:{type:[Boolean,String],default:false},
		target:Object
	},
	data:function(){
		var defaultBorderColor="#eeeeee"
		,	isColor=/^#[a-fA-F0-9]{6}$/.test(this.border)
		,	borderColor=isColor?this.border:defaultBorderColor
		;
		return {
			borderColor
		}
	},
	computed:{
		realSpace:function(){
			var value=parseInt(this.space);
	        if(_.isNumber(value)){
	        	if(_.inRange(value,-1,51)){
	        		return (value/2)||0
	        	}
	        }
	        return 0;
	    },
	    realCol(){
	    	var value=this.col;
	    	if(_.isNumber(value)){
				if(_.inRange(value,0,100)){
					return parseInt(value)||1
				}else{
					return 1;
				}
			}else if(_.isArray(value)&&_.every(value,_.isNumber)){
				return value.map(item=>parseInt(item)||1);
			}else{
				return parseInt(value)||1;
			}
	    },
	    containerStyle(){
	    	return {
	    		'margin-right':'-'+this.realSpace+'px',
	    		'margin-bottom':'-'+this.realSpace+'px'
	    	}
	    },
	    boxShadow(){
	    	if(this.border&&this.realSpace==0){
	    		return '0px 0px 0px 1px '+this.borderColor
	    	}
	    	return
	    }
	}
}
</script>
<style lang="scss">
@for $i from 1 through 5{
	.cmui-list-col#{$i}{
		.cmui-list-item:nth-of-type(#{$i}n+1){
			clear:left;
		}
	}
}
</style>
